const TokenConfirmationCheck = () => import('@app/2Factor/TokenConfirmationCheck')

export function install(Vue) {
  Vue.component('TokenConfirmationCheck', TokenConfirmationCheck)
}

export default { install }
